// src/pages/Compose.jsx
// Compose (3.20.0): its own tab, between Overview and Outbox. 3.27.0: the
// full Compose form (receivers, attachments, cover sheet, Preview, Contacts,
// Schedule, Advanced; components/SendFaxModal).
import SendFaxModal from '../components/SendFaxModal';
import { PAGE_TITLE } from '../theme/tabs';
import Emo from '../components/Emo';

export default function Compose({ onOpen }) {
  return (
    <div>
      <h2 style={PAGE_TITLE} className="cp-title"><Emo e="✍️" /> Compose</h2>
      <p style={{ margin: '-6px 0 16px', color: 'var(--t-607d8b)', fontSize: 14 }}>
        Attach documents, fill in the cover sheet, and send. You'll find it in{' '}
        <button onClick={() => onOpen('outgoing')} style={{ background: 'none', border: 'none', padding: 0, color: 'var(--t-00695c)', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', fontSize: 14 }}>Outbox</button>
        {' '}once it's sent.
      </p>
      <SendFaxModal inline onClose={() => {}} />
    </div>
  );
}
